import * as React from "react";
const SvgFiRrWhistle = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-whistle_svg__a)">
      <path
        fill="#062147"
        d="M8 12a4 4 0 1 0 0 8 4 4 0 0 0 0-8m0 6a2 2 0 1 1 0-4 2 2 0 0 1 0 4M21.5 8H8.229a8.15 8.15 0 0 0-8.207 7.394A8 8 0 0 0 8.006 24q.643 0 1.279-.1a7.96 7.96 0 0 0 5.908-4.46A7.9 7.9 0 0 0 16 16.152a1 1 0 0 1 .786-1.006l5.161-.938A2.5 2.5 0 0 0 24 11.748V10.5A2.5 2.5 0 0 0 21.5 8m.5 3.748a.5.5 0 0 1-.411.492l-5.162.939A2.98 2.98 0 0 0 14 16.112a5.9 5.9 0 0 1-.607 2.46 5.986 5.986 0 0 1-11.375-3.03A6.144 6.144 0 0 1 8.229 10H21.5a.5.5 0 0 1 .5.5zM9 4V1a1 1 0 0 1 2 0v3a1 1 0 1 1-2 0m3.607.553 1.5-3a1 1 0 0 1 1.79.894l-1.5 3a1 1 0 1 1-1.79-.894m-8.5-2.1a1 1 0 1 1 1.786-.9l1.516 3a1 1 0 1 1-1.785.9z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-whistle_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrWhistle;
